(function () {
    'use strict';

    angular.module("imApp").factory("laboursService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1168,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
